// extracted by mini-css-extract-plugin
module.exports = {"root":"PlaceAutoComplete_root__1RDXy"};